<template>
  <div id="product">
    <div class="item-area section-padding pb-bottom">
      <div class="container">
        <div class="row">

          <!-- ======================== LEFT AREA ======================== -->
          <div class="col-12 col-lg-9 pr-left">

            <!-- 타이틀 -->
            <div class="section-tittle mt-2 mb-10">
              <div class="title-accent-line"></div>
              <h2>{{productDetail.pdtNameKor}}</h2>
              <p class="pdt-remarks">{{productDetail.pdtRemarks}}</p>
            </div>

            <!-- 사진 캐러셀 -->
            <div class="carousel-wrap" v-if="productImage.length > 0">
              <div id="carouselDetail" class="carousel slide" data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="3000">
                <div class="carousel-indicators">
                  <button type="button"
                          v-for="(slide, index) in productImage.length"
                          :key="index"
                          :data-bs-target="'#carouselDetail'"
                          :data-bs-slide-to="index"
                          :class="{ active: index === 0 }"
                          :aria-current="index === 0 ? 'true' : null"
                          :aria-label="'Slide ' + (index + 1)">
                  </button>
                </div>
                <div class="carousel-inner">
                  <div :class="`carousel-item ${i==0 ? 'active' : ''}`" :key="i" v-for="(dImg, i) in productImage">
                    <img :src="`/download/${productId}/${dImg.imgName}`" class="d-block w-100" alt="...">
                  </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselDetail" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselDetail" data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>

            <!-- 상품번호 -->
            <div class="pdt-code-wrap text-end">
              <span class="pdt-code-badge">No. {{productDetail.pdtCode}}</span>
            </div>

            <!-- 교통편, 체크포인트 -->
            <div class="vech-wrap">
              <div class="vech-title fs-6">여정안내</div>
              <table class="table vech-table">
                <tbody>
                  <tr>
                    <td class="stand">출&nbsp;&nbsp;발</td>
                    <td class="sub" v-if="productDetail.salesRoute === 'E'"> — </td>
                    <td class="sub" v-else>
                      <div v-if="productDetail.transFlag != '0'">
                        <span class="trans-label">교통편</span> <span class="trans-none">불포함</span>
                      </div>
                      <div v-else>
                        <b class="trans-name">
                          <span v-if="pdtTransInfo1.dmobileCodeName != undefined">
                            {{pdtTransInfo1.dmobileCodeName}} ({{pdtTransInfo1.dmobileCode}}{{pdtTransInfo1.dpTpCode}})
                          </span>
                        </b>
                        <span class="trans-route" v-if="pdtTransInfo1.ddCodeName != undefined">
                          {{pdtTransInfo1.ddCodeName}}({{pdtTransInfo1.d_dpTime}})
                          <i class="bi bi-arrow-right"></i>
                          {{pdtTransInfo1.daCodeName}}({{pdtTransInfo1.d_arTime}})
                        </span>
                      </div>
                      <div v-if="productDetail.transRemarks_dp != undefined">
                        <small v-html="getStringFormat(this.productDetail.transRemarks_dp)" class="trans-remark"></small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="stand">도&nbsp;&nbsp;착</td>
                    <td class="sub" v-if="productDetail.salesRoute === 'E'"> — </td>
                    <td class="sub" v-else>
                      <div v-if="productDetail.transFlag != '0'">
                        <span class="trans-label">교통편</span> <span class="trans-none">불포함</span>
                      </div>
                      <div v-else>
                        <b class="trans-name">
                          <span v-if="pdtTransInfo1.rmobileCodeName != undefined">
                            {{pdtTransInfo1.rmobileCodeName}} ({{pdtTransInfo1.rmobileCode}}{{pdtTransInfo1.rtTpcode}})
                          </span>
                        </b>
                        <span class="trans-route" v-if="pdtTransInfo1.rdCodeName != undefined">
                          {{pdtTransInfo1.rdCodeName}}({{pdtTransInfo1.r_dpTime}})
                          <i class="bi bi-arrow-right"></i>
                          {{pdtTransInfo1.raCodeName}}({{pdtTransInfo1.r_arTime}})
                        </span>
                      </div>
                      <div v-if="productDetail.transRemarks_ar != undefined">
                        <small v-html="getStringFormat(this.productDetail.transRemarks_ar)" class="trans-remark"></small>
                      </div>
                    </td>
                  </tr>
                  <tr class="checkpoint-row">
                    <td class="stand check">체크<br>사항</td>
                    <td class="sub">
                      <small class="checkPoint">{{this.productDetail.supLookup}}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 포함 / 불포함 -->
            <div class="in-non-wrap">
              <div class="in-non-grid">
                <div class="in-non-card include-card">
                  <div class="in-non-header include-header">
                    <!-- <i class="fa-regular fa-circle-check fa-sm"></i>&nbsp; 포함사항 -->
                    <i class="bi bi-emoji-smile"></i>&nbsp; 포함사항
                  </div>
                  <pre class="inclusion in-non-body">{{ this.productDetail.inContent }}</pre>
                </div>
                <div class="in-non-card exclude-card">
                  <div class="in-non-header exclude-header">
                    <!-- <i class="fa-solid fa-xmark fa-sm"></i>&nbsp; 불포함사항 -->
                    <i class="bi bi-emoji-expressionless"></i>&nbsp; 불포함사항
                  </div>
                  <pre class="notInclusion in-non-body">{{ this.productDetail.exContent }}</pre>
                </div>
              </div>
            </div>

            <!-- 카테고리 탭 -->
            <div class="category">
              <div class="tab-content mt-4">
                <!-- 탭 메뉴 -->
                <section class="clist">
                  <div class="p-1">
                    <ul class="nav nav-tabs justify-content-center">
                      <li class="nav-item">
                        <a data-bs-toggle="tab">
                          <a class="nav-link active show" href="#tab-1"><span>상품설명</span></a>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a data-bs-toggle="tab">
                          <a class="nav-link" href="#tab-2"><span>안내사항</span></a>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a data-bs-toggle="tab">
                          <a class="nav-link" href="#tab-3"><span>취소안내</span></a>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a data-bs-toggle="tab">
                          <a class="nav-link" href="#tab-4"><span>이용후기</span></a>
                        </a>
                      </li>
                      <li class="nav-item" @click="inquiryProduct()">
                        <a data-bs-toggle="tab">
                          <a class="nav-link" href="#"><span>상품문의</span></a>
                        </a>
                      </li>
                    </ul>
                  </div>
                </section>

                <!-- 상품상세이미지 -->
                <section class="productDetail">
                  <!-- <div v-if="productDetail.cueingFlag === 'Y' && cueingUrl">
                    <div class="tab-pane mb-5 active show" id="tab-1">
                      <iframe
                        :src="cueingUrl"
                        class="cueing-iframe"
                        frameborder="0"
                        scrolling="no"
                        ref="cueingIframe"
                        title="상품 상세"
                        @load="resizeCueingIframe"
                      ></iframe>
                    </div>
                  </div> -->

                  <div v-if="productDetail.cueingFlag === 'Y' && cueingUrl">
                    <div class="tab-pane mb-5 active show" id="tab-1">
                      <div class="cueing-iframe-wrap">
                        <iframe
                          :src="cueingUrl"
                          class="cueing-iframe"
                          frameborder="0"
                          scrolling="no"
                          ref="cueingIframe"
                          title="상품 상세"
                          @load="resizeCueingIframe"
                        ></iframe>

                        <!-- Android에서만 오버레이 렌더 -->
                        <div
                          v-if="isAndroid"
                          class="cueing-touch-overlay"
                          @touchstart.passive="onCueingTouchStart"
                          @touchmove.passive="onCueingTouchMove"
                          @touchend="onCueingTouchEnd"
                          @touchcancel="onCueingTouchEnd"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div v-else-if="quillFlag === 'Y'">
                    <div class="tab-pane mb-5 active show" id="tab-1">
                      <div class="row">
                        <div class="markdown-body ql-editor" v-html="renderedHtml"></div>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="tab-pane mb-5 active show" id="tab-1" v-if="!mobileDisplay">
                      <div class="row">
                        <div class="row" v-if="productDetailImage.length > 0">
                          <div
                            style="width: 100%; padding-left:14%;"
                            :key="i"
                            v-for="(detailImg, i) in productDetailImage"
                          >
                            <img
                              :src="`/download/${productId}/${detailImg.imgName}`"
                              class="img-fluid"
                              style="width:77%; padding-bottom: 10px;"
                            />
                          </div>
                        </div>

                        <div class="row" v-else>
                          <div class="col-12">
                            <img
                              :src="`/download/noImage/noImage.jpg`"
                              class="img-fluid"
                              style="width:77%; padding-bottom: 10px;"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-pane mb-5 active show full-width-row" id="tab-1" v-else-if="mobileDisplay">
                      <div class="row">
                        <div class="row" v-if="productDetailImage.length > 0">
                          <div class="col-12" :key="i" v-for="(detailImg, i) in productDetailImage">
                            <img
                              :src="`/download/${productId}/${detailImg.imgName}`"
                              class="img-fluid"
                              style="width:100%; padding-bottom: 10px;"
                            />
                          </div>
                        </div>

                        <div class="row" v-else>
                          <div class="col-12">
                            <img
                              :src="`/download/noImage/noImage.jpg`"
                              class="img-fluid"
                              style="width:100%; padding-bottom: 10px;"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- 안내사항 -->
                <div class="tab-pane my-5" id="tab-2">
                  <div class="tab-section-inner">
                    <div class="tab-section-title">안내사항</div>
                    <pre class="supPre tab-pre-content">{{ this.productDetail.supPrecaution }}</pre>
                  </div>
                </div>

                <!-- 취소안내 -->
                <div class="tab-pane my-5" id="tab-3">
                  <div class="tab-section-inner">
                    <div class="tab-section-title">취소수수료 안내</div>
                    <pre class="supCxl tab-pre-content">{{ this.productDetail.supCancellation }}</pre>
                  </div>
                </div>

                <!-- 이용후기 -->
                <div class="tab-pane creview my-5" id="tab-4">
                  <div class="tab-section-title">이용후기</div>
                  <div class="review-divider"></div>
                  <div class="container">
                    <div v-if="this.reviewList.length > 0">
                      <div class="review-item" :key="i" v-for="(rl, i) in this.reviewList">
                        <div class="review-img-wrap" v-if="rl.imgName && rl.iUseFlag !== 'N'">
                          <img :src="`/download/review/${rl.revCode}/${rl.imgName}`" class="review-img" />
                        </div>
                        <div class="review-content">
                          <div class="review-top">
                            <div class="reviewt d-inline-block text-truncate" style="max-width: 330px;" v-if="rl.insId === this.user.email">
                              {{ rl.nTitle }}&nbsp;
                              <button type="button" class="btn-review-edit" @click="changeReview(rl.revCode, rl.seqNotice, rl.seqImg);">수정</button>
                            </div>
                            <div class="reviewt d-inline-block text-truncate" style="max-width: 330px;" v-else>{{ rl.nTitle }}</div>
                          </div>
                          <div class="reviewn">
                            <span class="review-name">{{ rl.rId.substring(0,3) }}○○○님</span>
                            <span class="review-date">{{ this.getDateFormat(rl.rDate) }}</span>
                          </div>
                          <pre class="reviewContent review-body">{{ rl.nContent }}</pre>
                        </div>
                      </div>
                    </div>
                    <div v-else class="review-empty">
                      <i class="bi bi-chat-square-text"></i>
                      <p>아직 등록된 후기가 없습니다.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- /pr-left -->


          <!-- ======================== 오른쪽 사이드바 ======================== -->
          <div class="col-md-3">
            <div class="pr-right">
              <div class="container px-0">

                <!-- 달력형 상품 -->
                <div class="calendar" v-if="this.dTypeFlag === 'Y'">
                  <div class="calendar-header">
                    <button class="calendarbtn" @click="previousMonth()">
                      <i class="bi bi-chevron-left"></i>
                    </button>
                    <div class="d-flex align-items-center gap-2">
                      <button class="calendarbtn" @click="goToCurrentMonth()">
                        <i class="bi bi-calendar3"></i>
                      </button>
                      <div class="calendar-header-date">
                        {{ this.currentDate ? this.currentDate.format('YYYY-MM') : '' }}
                      </div>
                    </div>
                    <button class="calendarbtn" @click="nextMonth()">
                      <i class="bi bi-chevron-right"></i>
                    </button>
                  </div>
                  <div class="calendar-body">
                    <div class="calendar-row cal-header-row">
                      <div class="calendar-day-header text-danger">일</div>
                      <div class="calendar-day-header">월</div>
                      <div class="calendar-day-header">화</div>
                      <div class="calendar-day-header">수</div>
                      <div class="calendar-day-header">목</div>
                      <div class="calendar-day-header">금</div>
                      <div class="calendar-day-header text-primary">토</div>
                    </div>
                    <div v-for="(week, index) in weeks" :key="index" class="calendar-row">
                      <div v-for="(day, index) in week" :key="index" class="calendar-day"
                           :class="{ today: isToday(day.date), selected: isSelected(day.date)}"
                           @click="goTo('resBtn');selectDate_new(day.date)">
                        <div v-if="day.date && day.date.day() === 0" class="calendar-date text-danger">{{ day.date.date() }}</div>
                        <div v-else-if="day.date && day.date.day() === 6" class="calendar-date text-primary">{{ day.date.date() }}</div>
                        <div v-else-if="day.date && (day.date.day() !== 6 && day.date.day() !== 0)" class="calendar-date">{{ day.date.date() }}</div>
                        <div v-if="day.price" class="calendar-price">
                          {{ formatManCurrency(day.price) }}<span class="price-unit">만</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="sidebar-divider" v-if="this.inquiryFlag === 'Y'"></div>

                  <!-- 옵션 선택 영역 -->
                  <div class="price" v-if="this.inquiryFlag === 'Y'">
                    <table>
                      <tr class="row col-12 text-center">
                        <td>
                          <div class="selected-date-badge">
                            <i class="bi bi-calendar-check"></i>
                            {{ this.selectedDate }} ({{ this.getDayOfWeek(this.selectedDate) }})
                          </div>
                        </td>
                      </tr>
                      <tr class="row col-12" v-if="this.dirOptFlag === 'Y'">
                        <td>
                          <div class="opt-label">[필수입력사항]</div>
                          <div :key="i" v-for="(od, i) in this.dirOptInfo" class="mt-1">
                            <input type="text" class="opt-input" :placeholder="od.odName" v-model="od.odValue"/>
                          </div>
                        </td>
                      </tr>
                      <tr class="row col-12" v-if="this.selOptFlag == 'Y'">
                        <td>
                          <div class="opt-label">[필수선택옵션]</div>
                          <div class="opt-select-wrap">
                            <select class="opt-select" v-model="choicedSelOpt" @change="validateDirectOptions('opt', choicedSelOpt)">
                              <option value="noVal">옵션을 선택해주세요</option>
                              <option :value="os.os3" :key="j" v-for="(os,j) in selectedCalPdtPrice">
                                {{ os.os3 }} ({{ this.getCurrencyFormat(os.pdtPrice_org) }}원)
                              </option>
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr class="row col-12" v-if="addPdtFlag === 'Y' && hasAddPdt">
                        <td>
                          <div class="opt-label">[추가상품] <span style="font-size:0.7rem;">선택사항 · 복수선택 가능</span></div>
                          <div class="opt-select-wrap">
                            <select class="opt-select" v-model="choicedAddPdt" @change="validateDirectOptions('add', choicedAddPdt)">
                              <option value="noVal">추가상품을 선택해주세요</option>
                              <option v-for="ap in addPdtInfo" :key="ap.addSeq" :value="ap.addSeq"
                                      :disabled="Number(ap.addQty) <= 0 || isAddSelected(ap.addSeq)">
                                {{ addPdtLabel(ap) }}
                              </option>
                            </select>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <!-- 비달력형 상품 -->
                <div class="calendar" v-else>
                  <div class="noncal-pdt-info">
                    <p class="noncal-pdt-name">{{ this.productDetail.pdtNameKor }}</p>
                    <p class="noncal-price" v-for="(so, i) in selectedCalPdtPrice" :key="i">
                      <span class="noncal-opt-name">{{ so.os1 }}</span>
                      <span class="noncal-price-val">{{ this.getCurrencyFormat(so.pdtPrice_org) }}원</span>
                    </p>
                  </div>
                  <div class="sidebar-divider" v-if="this.inquiryFlag === 'Y'"></div>
                  <div class="price" v-if="this.inquiryFlag === 'Y'">
                    <table>
                      <tr class="row col-12" v-if="this.dirOptFlag === 'Y'">
                        <td>
                          <div class="opt-label">[필수입력사항]</div>
                          <div :key="i" v-for="(od, i) in this.dirOptInfo" class="mt-1">
                            <input type="text" class="opt-input" :placeholder="od.odName" v-model="od.odValue"/>
                          </div>
                        </td>
                      </tr>
                      <tr class="row col-12" v-if="this.selOptFlag == 'Y'">
                        <td>
                          <div class="opt-label">[필수선택옵션]</div>
                          <div class="opt-select-wrap">
                            <select class="opt-select" v-model="choicedSelOpt" @change="validateDirectOptions('opt', choicedSelOpt)">
                              <option value="noVal" disabled>옵션을 선택해주세요</option>
                              <option :value="os.os1" :key="j" v-for="(os,j) in selectedCalPdtPrice">
                                {{ os.os1 }} ({{ this.getCurrencyFormat(os.pdtPrice_org) }}원)
                              </option>
                            </select>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div class="sidebar-divider mt-2 mb-2" v-if="this.inquiryFlag === 'Y'"></div>
              <div id="resBtn"></div>

              <!-- 가격계산영역 -->
              <div class="total-P mt-1 mb-3" v-if="this.inquiryFlag === 'Y'">
                <table>
                  <tr class="row" style="width: 100%;" v-for="(item, index) in rsvData_temp" :key="index">
                    <td class="price-row-td">
                      <div class="price-opt-info" v-if="item.selOptName">
                        {{ item.selOptName }} / {{ item.departureDate }}
                        <span v-for="(val, idx) in item.directOptions" :key="idx"> / {{ val }}</span>
                        <span class="price-delete-btn" @click="deletePrice('opt', item.selOptName)">
                          <i class="bi bi-x-circle-fill"></i>
                        </span>
                      </div>
                      <div class="price-opt-info" v-if="item.addPdtName">
                        {{ item.addPdtName }} / {{ item.addPdtValue }}
                        <span class="price-delete-btn" @click="deletePrice('add', item.addSeq)">
                          <i class="bi bi-x-circle-fill"></i>
                        </span>
                      </div>
                      <div class="price-count-row" v-if="item.selOptName">
                        <div class="count-group">
                          <button class="count-btn minus" @click="numCount('opt', 'M', item.selOptName)">
                            <i class="bi bi-dash-lg"></i>
                          </button>
                          <span class="count-num">{{ item.count }}</span>
                          <button class="count-btn plus" @click="numCount('opt', 'P', item.selOptName)">
                            <i class="bi bi-plus-lg"></i>
                          </button>
                        </div>
                        <div class="price-amount">
                          <b>{{ this.getCurrencyFormat(item.pdtPrice * item.count) }}</b>
                          <span class="price-unit-won">원</span>
                        </div>
                      </div>
                      <div class="price-count-row" v-if="item.addPdtName">
                        <div class="count-group">
                          <button class="count-btn minus" @click="numCount('add', 'M', item.addSeq)">
                            <i class="bi bi-dash-lg"></i>
                          </button>
                          <span class="count-num">{{ item.count }}</span>
                          <button class="count-btn plus" @click="numCount('add', 'P', item.addSeq)">
                            <i class="bi bi-plus-lg"></i>
                          </button>
                        </div>
                        <div class="price-amount">
                          <b>{{ this.getCurrencyFormat(item.pdtPrice * item.count) }}</b>
                          <span class="price-unit-won">원</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>

                <div class="sidebar-divider mb-0" v-if="this.rsvData_temp.length > 0"></div>

                <!-- 총액 -->
                <table>
                  <tr v-if="this.selectedCalPdtPrice.length > 0">
                    <td class="total-price-td">
                      <div class="total-price-wrap">
                        <span class="total-label">총 상품액</span>
                        <span class="total-amount">{{ this.getCurrencyFormat(sumPdtPrice) }}<span class="total-won">원</span></span>
                      </div>
                    </td>
                  </tr>
                </table>

                <!-- 예약하기 버튼 (PC) -->
                <table>
                  <tr v-if="this.selectedCalPdtPrice.length > 0">
                    <td class="text-center align-middle" colspan="2">
                      <div class="pr-go text-center" id="p_resBtn">
                        <!-- [임시] 예약차단 -->
                        <div class="pr-go-blocked" v-if="reservationBlock">
                          <i class="bi bi-lock-fill"></i> 예약 준비중
                        </div>
                        <a v-else href="javascript: void(0)" @click="orderCheck_new('p')">
                          <p>예약하기</p>
                        </a>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div><!-- /col-md-3 -->


          <!-- ======================== 모바일 예약 ======================== -->
          <div class="container mobile-cal">
            <a class="openm" @click="toggleModal()">
              <i class="bi bi-calendar-check me-2"></i>예약시작
            </a>

            <!-- v-if 제거 → :class로 열림/닫힘 제어 (DOM 유지, 슬라이드 애니메이션 정상동작) -->
            <div class="modal2" :class="{ open: showModal2 }" @click.self="closeModal2()">
              <div class="body">
                <div class="container">

                  <!-- 달력형 -->
                  <div class="calendar" v-if="dTypeFlag === 'Y'">
                    <div class="calendar-header">
                      <button class="calendarbtn" @click="previousMonth()"><i class="bi bi-chevron-left"></i></button>
                      <div class="d-flex align-items-center gap-2">
                        <button class="calendarbtn" @click="goToCurrentMonth()"><i class="bi bi-calendar3"></i></button>
                        <div class="calendar-header-date">{{ currentDate ? currentDate.format('YYYY-MM') : '' }}</div>
                      </div>
                      <button class="calendarbtn" @click="nextMonth()"><i class="bi bi-chevron-right"></i></button>
                    </div>
                    <div class="calendar-body">
                      <div class="calendar-row">
                        <div class="calendar-day-header text-danger">일</div>
                        <div class="calendar-day-header">월</div>
                        <div class="calendar-day-header">화</div>
                        <div class="calendar-day-header">수</div>
                        <div class="calendar-day-header">목</div>
                        <div class="calendar-day-header">금</div>
                        <div class="calendar-day-header text-primary">토</div>
                      </div>
                      <div v-for="(week, index) in weeks" :key="index" class="calendar-row">
                        <div v-for="(day, index) in week" :key="index" class="calendar-day" :class="{ today: isToday(day.date), selected: isSelected(day.date)}" @click="goTo('resBtn');selectDate_new(day.date)">
                          <div v-if="day.date && day.date.day() === 0" class="calendar-date text-danger">{{ day.date.date() }}</div>
                          <div v-else-if="day.date && day.date.day() === 6" class="calendar-date text-primary">{{ day.date.date() }}</div>
                          <div v-else-if="day.date && (day.date.day() !== 6 && day.date.day() !== 0)" class="calendar-date">{{ day.date.date() }}</div>
                          <div v-if="day.price" class="calendar-price">
                            {{ formatManCurrency(day.price) }}<span class="price-unit">만</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="sidebar-divider" v-if="inquiryFlag === 'Y'"></div>

                    <div class="price" v-if="inquiryFlag === 'Y'">
                      <table>
                        <tr class="row col-12 text-center">
                          <td>
                            <div class="selected-date-badge">
                              <i class="bi bi-calendar-check"></i>
                              {{ selectedDate }} ({{ getDayOfWeek(selectedDate) }})
                            </div>
                          </td>
                        </tr>
                        <tr class="row col-12" v-if="dirOptFlag === 'Y'">
                          <td>
                            <div class="opt-label">[필수입력사항]</div>
                            <div v-for="(od, i) in dirOptInfo" :key="i" class="mt-1">
                              <input type="text" class="opt-input w-100" :placeholder="od.odName" v-model="od.odValue"/>
                            </div>
                          </td>
                        </tr>
                        <tr class="row col-12 mt-3" v-if="selOptFlag == 'Y'">
                          <td>
                            <div class="opt-label">[필수선택옵션]</div>
                            <div class="opt-select-wrap w-100">
                              <select class="opt-select w-100" v-model="choicedSelOpt" @change="validateDirectOptions('opt', choicedSelOpt)">
                                <option value="noVal">옵션을 선택해주세요</option>
                                <option :value="os.os3" :key="j" v-for="(os,j) in selectedCalPdtPrice">
                                  {{ os.os3 }} ({{ getCurrencyFormat(os.pdtPrice_org) }}원)
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                        <!-- 추가상품: 선택사항 / 복수선택 -->
                        <tr class="row col-12" v-if="addPdtFlag === 'Y' && hasAddPdt">
                          <td>
                            <div class="opt-label">[추가상품] <span style="font-size:0.7rem;">선택사항 · 복수선택 가능</span></div>
                            <div class="opt-select-wrap w-100">
                              <select class="opt-select w-100" v-model="choicedAddPdt" @change="validateDirectOptions('add', choicedAddPdt)">
                                <option value="noVal">추가상품을 선택해주세요</option>
                                <option v-for="ap in addPdtInfo" :key="ap.addSeq" :value="ap.addSeq"
                                        :disabled="Number(ap.addQty) <= 0 || isAddSelected(ap.addSeq)">
                                  {{ addPdtLabel(ap) }}
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <!-- 비달력형 -->
                  <div class="calendar" v-else>
                    <div class="noncal-pdt-info">
                      <p class="noncal-pdt-name">{{ productDetail.pdtNameKor }}</p>
                      <p class="noncal-price" v-for="(so, i) in selectedCalPdtPrice" :key="i">
                        <span class="noncal-opt-name">{{ so.os1 }}</span>
                        <span class="noncal-price-val">{{ getCurrencyFormat(so.pdtPrice_org) }}원</span>
                      </p>
                    </div>
                    <div class="price" v-if="inquiryFlag === 'Y'">
                      <table>
                        <tr class="row col-12" v-if="dirOptFlag === 'Y'">
                          <td>
                            <div class="opt-label">[필수입력사항]</div>
                            <div v-for="(od, i) in dirOptInfo" :key="i" class="mt-1">
                              <input type="text" class="opt-input w-100" :placeholder="od.odName" v-model="od.odValue"/>
                            </div>
                          </td>
                        </tr>
                        <tr class="row col-12 mt-3" v-if="selOptFlag == 'Y'">
                          <td>
                            <div class="opt-label">[필수선택옵션]</div>
                            <div class="opt-select-wrap w-100">
                              <select class="opt-select w-100" v-model="choicedSelOpt" @change="validateDirectOptions('opt', choicedSelOpt)">
                                <option value="noVal">옵션을 선택해주세요</option>
                                <option :value="os.os1" :key="j" v-for="(os,j) in selectedCalPdtPrice">
                                  {{ os.os1 }} ({{ getCurrencyFormat(os.pdtPrice_org) }}원)
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                </div><!-- /container -->

                <div class="sidebar-divider mt-3 mb-2" v-if="inquiryFlag === 'Y'"></div>

                <!-- 모바일 가격계산 -->
                <div class="total-P mt-1 mb-3" v-if="inquiryFlag === 'Y'">
                  <table>
                    <tr class="row" style="width: 100%;" v-for="(item, index) in rsvData_temp" :key="index">
                      <td class="price-row-td">
                        <div class="price-opt-info" v-if="item.selOptName">
                          {{ item.selOptName }} / {{ item.departureDate }}
                          <span v-for="(val, idx) in item.directOptions" :key="idx"> / {{ val }}</span>
                          <span class="price-delete-btn" @click="deletePrice('opt', item.selOptName)"><i class="bi bi-x-circle-fill"></i></span>
                        </div>
                        <div class="price-count-row" v-if="item.selOptName">
                          <div class="count-group">
                            <button class="count-btn minus" @click="numCount('opt', 'M', item.selOptName)"><i class="bi bi-dash-lg"></i></button>
                            <span class="count-num">{{ item.count }}</span>
                            <button class="count-btn plus" @click="numCount('opt', 'P', item.selOptName)"><i class="bi bi-plus-lg"></i></button>
                          </div>
                          <div class="price-amount">
                            <b>{{ getCurrencyFormat(item.pdtPrice * item.count) }}</b>
                            <span class="price-unit-won">원</span>
                          </div>
                        </div>
                        <div class="price-opt-info" v-if="item.addPdtName">
                          {{ item.addPdtName }} / {{ item.addPdtValue }}
                          <span class="price-delete-btn" @click="deletePrice('add', item.addSeq)"><i class="bi bi-x-circle-fill"></i></span>
                        </div>
                        <div class="price-count-row" v-if="item.addPdtName">
                          <div class="count-group">
                            <button class="count-btn minus" @click="numCount('add', 'M', item.addSeq)"><i class="bi bi-dash-lg"></i></button>
                            <span class="count-num">{{ item.count }}</span>
                            <button class="count-btn plus" @click="numCount('add', 'P', item.addSeq)"><i class="bi bi-plus-lg"></i></button>
                          </div>
                          <div class="price-amount">
                            <b>{{ getCurrencyFormat(item.pdtPrice * item.count) }}</b>
                            <span class="price-unit-won">원</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>

                  <div class="sidebar-divider mb-0" v-if="rsvData_temp.length > 0"></div>

                  <!-- 총액 (모바일) -->
                  <table>
                    <tr v-if="selectedCalPdtPrice.length > 0">
                      <td class="total-price-td">
                        <div class="total-price-wrap">
                          <span class="total-label">총 상품액</span>
                          <span class="total-amount">{{ getCurrencyFormat(sumPdtPrice) }}<span class="total-won">원</span></span>
                        </div>
                      </td>
                    </tr>
                  </table>

                  <div id="resBtn_m"></div>

                  <!-- 예약하기 버튼 (모바일) -->
                  <table>
                    <tr v-if="selectedCalPdtPrice.length > 0">
                      <td class="text-center align-middle" colspan="2">
                        <div class="pr-go text-center" id="m_resBtn">
                          <!-- [임시] 예약차단 -->
                          <div class="pr-go-blocked" v-if="reservationBlock">
                            <i class="bi bi-lock-fill"></i> 예약 준비중
                          </div>
                          <a v-else href="javascript: void(0)" @click="orderCheck_new('p')">
                            <p>예약하기</p>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>

                <!-- 닫기 버튼 -->
                <a class="closem">
                  <i class="bi bi-x-circle-fill" style="cursor:pointer; font-size:1.5rem;" @click.stop="closeModal2()"></i>
                </a>
              </div>
            </div>
          </div><!-- /mobile-cal -->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {genCode} from '../assets/js/genCode'
import axios from 'axios';
import { getActiveBlock } from '../assets/js/reservationBlock'   // [임시] 예약차단 - 정규화 시 제거

export default {
  data() {
    return {
      memberFlag: '',
      pdtminPrice: 0,
      pdtbasicPrice: 0,
      prcCode: '',
      osCode: '',
      dirOptFlag: 'N',
      selOptFlag: 'N',
      dTypeFlag: '',
      calPdtPrice: [],
      priceData: [],
      dirOptInfo: [],
      selectedCalPdtPrice: [],
      inquiryFlag: 'N',
      rsvData_temp: [],
      showModal2: false,
      choicedSelOpt: 'noVal',
      choicedAddPdt: 'noVal',
      currentDate: null,
      productId: '',
      productDetail: {},
      pdtTransInfo1: {},
      productImage: [],
      productDetailImage: [],
      selectedDate: null,
      selectedPrice: null,
      reqReserveCode: '', 
      totalPrice: 0,
      reviewList: [],
      rShowFlag: 'N',
      noPopFlag: 'N',
      reqDptDate: null,
      reqRtnDate: null,
      memFlag: 'N',
      optCode: 'noCode',
      sp: '',
      addPdtFlag: 'N',
      addCode: '',
      addPdtInfo: [],
      priceForCoupon: 0,
      quillFlag: 'N',
      filename: 'productDetail.md',
      renderedHtml: '',
      jointFlag: '',
      memDCRate: 5,
      memDCAmt: 0,
      cueingContent: '',
      cueingUrl: '',
      resizeObserver: null,

      cueingScrollHandler: null,

      // 큐잉iframe 스크롤지원
      isAndroid: false,
      isIOS: false,

      isOrdering: false,     // 중복클릭 방지      

      // [임시] 예약차단 - 정규화 시 제거
      reservationBlock: null,    // 예약차단 규칙 (null이면 예약 가능)
      blockTimer: null,          // 예약차단 해제 타이머
    };
  },
  created() {
    this.user = this.$store.state.user;
    this.productId = this.$route.query.productId;
    this.salesRoute = this.$route.query.salesRoute;
    this.conEmail = this.user.email;

    // [임시] 예약차단 - 정규화 시 제거
    this.reservationBlock = getActiveBlock(this.productId);
    this.scheduleBlockRelease();
    
    if (this.$store.state.user.handlerId != undefined) 
    {
      this.userInfo = this.$store.state.user.handlerId;
    } 
    else if (this.$store.state.user.email != undefined) 
    {
      this.userInfo = this.$store.state.user.email;
    } 
    else 
    {
      this.userInfo = "";
    }
    
    if (this.$isMobile()) {
      this.mobileDisplay = true;
      // ★ Android/iOS 판별
      const ua = navigator.userAgent.toLowerCase();
      this.isAndroid = ua.includes('android');
      this.isIOS = /iphone|ipad|ipod/.test(ua);
    } 
    else 
    {
      this.mobileDisplay = false;
    }

    if(this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.userInfo.joinFlag == 'H') {
      this.k_name = (!this.user.nickname) ? "" : this.user.nickname;
      let kakaoPhone = ""
      if(this.user.phone != undefined && this.user.phone.charAt(0) === '+') {
        kakaoPhone = this.user.phone.replace("+82 ", "0")
      }
      this.k_tel = (!this.user.phone) ? "" : kakaoPhone.replace(/-/g,"");
    } else {
      this.k_name = this.user.name;
      this.k_tel = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g,"");
    }
    this.getProductDetail_new();
  },

  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('beforeunload', this.showPopupOnRefresh)

    // document.querySelector(".js-click-modal").addEventListener("click", () => {
    //   document.querySelector(".modal2").classList.toggle("open");
    // });
    // document.querySelector(".js-close-modal").addEventListener("click", () => {
    //   document.querySelector(".modal2").classList.remove("open");
    // });
    
    if(this.user.email != undefined) {
      document.getElementById("recent-item").style.display = "none";
    }
    this.countPageView(this.salesRoute, this.productId)

    /* cueing iframe 스크롤 브릿지 */
    this.cueingScrollHandler = (e) => {
      if (e.data && e.data.type === 'cueingScroll') {
        window.scrollBy({
          top: e.data.deltaY,
          left: e.data.deltaX,
          behavior: 'auto',          // 'smooth'로 바꾸면 부드럽지만 약간 끊김
        });
      }
    };
    window.addEventListener('message', this.cueingScrollHandler);
  },

  beforeUnmount() {
    window.removeEventListener('beforeunload', this.showPopupOnRefresh)
    
    if (this.resizeObserver) 
    {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.cueingScrollHandler) {
      window.removeEventListener('message', this.cueingScrollHandler);
      this.cueingScrollHandler = null;
    }

    // [임시] 예약차단 타이머 정리 - 정규화 시 제거
    clearTimeout(this.blockTimer);
    this.blockTimer = null;
  },

  beforeRouteLeave(to, from, next) {
    if (this.inquiryFlag === 'Y' && this.noPopFlag != 'Y') {
      this.showPopupOnBack().then(shouldProceed => {
        if (shouldProceed) { next() } else { next(false) }
      })
    } else {
      next()
    }
  },
  computed: {
    user() { return this.$store.state.user; },

    // 선택 가능한 추가상품이 1개라도 있는지
    hasAddPdt() {
      return Array.isArray(this.addPdtInfo) && this.addPdtInfo.some(ap => Number(ap.addQty) > 0);
    },

    weeks() {
      const weeks = [];
      let weekDays = [];
      let day = this.currentDate ? this.currentDate.clone().startOf('month').startOf('week') : moment().startOf('month').startOf('week');
      const startOfMonth = this.currentDate ? this.currentDate.clone().startOf('month') : moment().startOf('month');
      const endOfMonth = this.currentDate ? this.currentDate.clone().endOf('month') : moment().endOf('month');
      const endDate = this.currentDate ? this.currentDate.clone().endOf('month').endOf('week') : moment().endOf('month').endOf('week');
      while (day.isSameOrBefore(endDate)) {
        if (day.isSameOrAfter(startOfMonth) && day.isSameOrBefore(endOfMonth)) {
          weekDays.push({ date: day.clone(), price: this.getPrice(day.format('YYYY-MM-DD')) });
        } else {
          weekDays.push({ date: null, price: null });
        }
        if (weekDays.length === 7) { weeks.push(weekDays); weekDays = []; }
        day.add(1, 'day');
      }
      return weeks;
    },
    sumPdtPrice() {
      if (!this.rsvData_temp || !this.rsvData_temp.length || this.rsvData_temp == undefined || this.rsvData_temp.length < 1) return 0;
      else { return this.rsvData_temp.reduce((sum, item) => sum + (item.pdtPrice * (item.count ?? 0)), 0) }
    }
  },
  watch: {
    sumPdtPrice: {
      immediate: true,
      handler(newVal) { this.totalPrice = newVal; }
    },
  },
  methods: {
    // ================= [임시] 예약차단 - 정규화 시 제거 =================
    // 클릭 시점마다 재계산 (화면을 띄워둔 채 시각이 바뀔 수 있음)
    blockedReservation() {
      const rule = getActiveBlock(this.productId);
      this.reservationBlock = rule;
      if (rule) {
        this.showModal2 = false;
        this.$swal.fire('', rule.message, 'info');
        return true;
      }
      return false;
    },

    // 차단 해제 시각에 버튼 자동 전환
    scheduleBlockRelease() {
      clearTimeout(this.blockTimer);
      this.blockTimer = null;
      if (!this.reservationBlock) return;

      const remain = this.reservationBlock.untilMs - Date.now();
      if (!(remain > 0)) return;      // 형식오류(NaN) 포함

      // setTimeout 최대치(약 24.8일) 초과 방지 → 최대 하루 단위로 나눠서 재확인
      this.blockTimer = setTimeout(() => {
        this.reservationBlock = getActiveBlock(this.productId);
        this.scheduleBlockRelease();
      }, Math.min(remain + 1000, 86400000));
    },
    // ===================================================================

    async countPageView(sRoute, pCode) {
      let vParam = "V"
      let countPageView = await this.$api("/api/proc_pdtCountPageView", {param:[ sRoute, pCode, vParam ]})
      if(countPageView.affectedRows > 0) { console.log("Thank you for your visit!") }
    },
    // 비정상적 금액이 있는 경우, 콘솔표시
    getCurrencyFormat(value) {
      const n = Number(value);
      if (value === null || value === undefined || value === '' || !isFinite(n)) {
        console.warn('[getCurrencyFormat] 비정상 금액:', value);
        return '-';
      }
      return this.$currencyFormat(n);
    },

    getStringFormat(text) { return this.$stringFormat(text); },
    getDateFormat(date) { return this.$dateFormat(date); },
    getDayOfWeek(dateString) { return this.$getDayOfWeek(dateString) },
    initializeCounts() {
      this.rsvData_temp = [];
      this.choicedSelOpt = "noVal"
      this.choicedAddPdt = "noVal"
    },

    // 추가상품 선택 여부
    isAddSelected(addSeq) {
      return this.rsvData_temp.some(item => item.addSeq != null && item.addSeq == addSeq);
    },

    // 추가상품 드롭다운 표시문구
    addPdtLabel(ap) {
      let label = `${ap.add1} ▶ ${ap.add2} (${this.getCurrencyFormat(ap.addPrice)}원)`;
      if (Number(ap.addQty) <= 0) label += ' - 마감';
      else if (this.isAddSelected(ap.addSeq)) label += ' - 선택됨';
      return label;
    },

    // 예약 진행 전 선택요건 검증 (통과 시 true)
    // ※ 추가상품은 선택사항이지만, 담은 추가상품의 수량이 0개면 차단
    validateReservation() {
      const warn = (msg) => { this.$swal.fire('', msg, 'warning'); return false; };

      const optItems = this.rsvData_temp.filter(item => item.selOptName);
      const addItems = this.rsvData_temp.filter(item => item.addSeq != null && item.addSeq !== '');

      // 1. 출발일 (달력형 상품)
      if (this.dTypeFlag === 'Y') 
      {
        if (!this.selectedDate) 
        {
          return warn('출발일을 선택해주세요.');
        }
        if (!(this.getPrice(this.selectedDate) > 0)) 
        {
          return warn('선택하신 날짜는 예약할 수 없습니다.<br>다른 날짜를 선택해주세요.');
        }
      }

      // 2. 필수선택옵션 0건
      if (optItems.length === 0) 
      {
        if (this.selOptFlag === 'Y') 
        {
          return warn('필수선택옵션을 선택해주세요.');
        }
        return warn('선택 가능한 옵션이 없습니다.<br>담당자에게 문의(1566-4602)하여 주십시오.');
      }

      // 3. 선택한 옵션 중 수량 0개
      const zeroOpt = optItems.find(item => (item.count ?? 0) < 1);
      if (zeroOpt) 
      {
        return warn(`"${zeroOpt.selOptName}" 옵션의 구매수량이 0개입니다.<br>수량을 지정하거나 삭제(×)해주세요.`);
      }

      // 4. 선택한 추가상품 중 수량 0개 (추가상품 자체는 선택사항이지만, 담았으면 1개 이상이어야 함)
      const zeroAdd = addItems.find(item => (item.count ?? 0) < 1);
      if (zeroAdd) 
      {
        return warn(`추가상품 "${zeroAdd.addPdtName}"의 수량이 0개입니다.<br>수량을 지정하거나 삭제(×)해주세요.`);
      }

      // 5. 필수입력사항 (옵션 추가 후 입력값을 지운 경우 대비)
      if (this.dirOptFlag === 'Y') 
      {
        const emptyDir = this.dirOptInfo.find(od => !String(od.odValue ?? '').trim());
        if (emptyDir) 
        {
          return warn(`"${emptyDir.odName}"에 입력값이 없습니다.`);
        }
      }

      // 6. 옵션의 출발일과 현재 선택일 일치 여부 (달력형)
      if (this.dTypeFlag === 'Y' && optItems.some(item => item.departureDate !== this.selectedDate)) 
      {
        return warn('선택일과 옵션 정보가 일치하지 않습니다.<br>날짜를 다시 선택해주세요.');
      }

      // 7. 총액
      if (!(this.sumPdtPrice > 0)) 
      {
        return warn('상품금액이 0원입니다. 선택내용을 확인해주세요.');
      }

      return true;
    },


    validateDirectOptions(param, choicedSelOpt) {
      if(param === "opt") 
      {
        // noVal 또는 빈값이면 즉시 종료
        if (!choicedSelOpt || choicedSelOpt === 'noVal') return false;

        if (this.dirOptFlag === 'Y') 
        {
          for (let i = 0; i < this.dirOptInfo.length; i++) 
          {
            if (this.dirOptInfo[i].odValue === '' || this.dirOptInfo[i].odValue == undefined) 
            {
              this.$swal.fire('', `"${this.dirOptInfo[i].odName}"에 입력값이 없습니다`, 'warning');
              return false;
            }
          }
        }

        let isDuplicate = this.rsvData_temp.some(item => item.selOptName === choicedSelOpt);

        if (isDuplicate) 
        { 
          this.$swal.fire('', `"${choicedSelOpt}" 옵션은 이미 선택되어 있습니다.`, 'warning'); return false; 
        }
        
        if(this.dTypeFlag === "Y") 
        {
          let pdtPrice_tmp = this.selectedCalPdtPrice.filter((item) => { return (item.os3 === choicedSelOpt)})

          // 매칭 결과 없으면 종료
          if (!pdtPrice_tmp.length) 
          {
            this.$swal.fire('', '선택한 옵션 정보를 찾을 수 없습니다.', 'warning');
            return false;
          }

          let pdtPrice = pdtPrice_tmp[0].pdtPrice_org
          let osSeq = pdtPrice_tmp[0].osSeq
          if (pdtPrice <= 0) 
          { 
            this.$swal.fire('', `"${choicedSelOpt}" 옵션은 선택할 수 없습니다(상품가격 비정상)`, 'warning'); return false; 
          }
          this.rsvData_temp.push({ selOptName: choicedSelOpt, departureDate: this.selectedDate, directOptions: this.dirOptInfo.map(opt => opt.odValue), count: 0, pdtPrice: pdtPrice, osSeq: osSeq });
        } 
        else 
        {
          let pdtPrice_tmp = this.selectedCalPdtPrice.filter((item) => { return (item.os1 === choicedSelOpt)})

          // 매칭 결과 없으면 종료
          if (!pdtPrice_tmp.length) 
          {
            this.$swal.fire('', '선택한 옵션 정보를 찾을 수 없습니다.', 'warning');
            return false;
          }

          let pdtPrice = pdtPrice_tmp[0].pdtPrice_org
          let osSeq = pdtPrice_tmp[0].osSeq
          
          if (pdtPrice <= 0) 
          { 
            this.$swal.fire('', `"${choicedSelOpt}" 옵션은 선택할 수 없습니다(상품가격 비정상)`, 'warning'); return false; 
          }
          this.rsvData_temp.push({ selOptName: choicedSelOpt, directOptions: this.dirOptInfo.map(opt => opt.odValue), count: 0, pdtPrice: pdtPrice, osSeq: osSeq });
        }
      }

      // 추가상품: 선택사항 / 복수선택 가능
      if (param === "add") 
      {
        if (this.addPdtFlag !== 'Y') return false;
        if (!choicedSelOpt || choicedSelOpt === 'noVal') return false;

        // 드롭다운은 항상 원위치 (다음 추가상품 선택 준비)
        const resetSelect = () => { this.choicedAddPdt = 'noVal'; };

        // 필수선택옵션을 먼저 담아야 추가상품 선택 가능 (실제 담긴 옵션 기준)
        if (this.selOptFlag === 'Y' && !this.rsvData_temp.some(item => item.selOptName)) 
        {
          this.$swal.fire('', '필수선택옵션을 먼저 선택해주세요', 'warning');
          resetSelect();
          return false;
        }

        const selectedAddProduct = this.addPdtInfo.find(ap => ap.addSeq == choicedSelOpt);
        if (!selectedAddProduct) 
        {
          this.$swal.fire('', '추가상품정보가 없습니다', 'warning');
          resetSelect();
          return false;
        }

        if (Number(selectedAddProduct.addQty) <= 0) 
        {
          this.$swal.fire('', `"${selectedAddProduct.add1}"은(는) 마감된 추가상품입니다.`, 'warning');
          resetSelect();
          return false;
        }

        if (this.isAddSelected(selectedAddProduct.addSeq)) 
        {
          this.$swal.fire('', '해당 추가상품은 이미 선택되어 있습니다.<br>수량은 +/− 버튼으로 조정해주세요.', 'warning');
          resetSelect();
          return false;
        }

        this.rsvData_temp.push({
          addSeq: selectedAddProduct.addSeq,
          addPdtName: selectedAddProduct.add1,
          addPdtValue: selectedAddProduct.add2,
          count: 1,                                       // 선택 즉시 1개
          pdtPrice: Number(selectedAddProduct.addPrice) || 0
        });
        resetSelect();
      }
    },

    //안드로이드 iframe 스크롤 대응
    onCueingTouchStart(e) {
      const t = e.touches[0];
      this._cTsX = t.clientX;
      this._cTsY = t.clientY;
      this._cLastY = t.clientY;
      this._cDecided = false;
      this._cIsVertical = false;
      this._cRafId = null;
    },

    onCueingTouchMove(e) {
      const t   = e.touches[0];
      const adx = Math.abs(t.clientX - this._cTsX);
      const ady = Math.abs(t.clientY - this._cTsY);
      const dy  = this._cLastY - t.clientY;

      /* 방향 결정 (최초 1회) */
      if (!this._cDecided && (ady > 10 || adx > 10)) {
        this._cIsVertical = ady > adx;
        this._cDecided = true;

        /* 가로 스와이프 → 오버레이 투명화하여 iframe에 위임 */
        if (!this._cIsVertical) {
          e.currentTarget.style.pointerEvents = 'none';
        }
      }

      /* 세로 스크롤 → rAF으로 부드럽게 */
      if (this._cIsVertical && dy !== 0) {
        if (!this._cRafId) {
          const scrollDy = dy;
          this._cRafId = requestAnimationFrame(() => {
            window.scrollBy(0, scrollDy);
            this._cRafId = null;
          });
        }
        this._cLastY = t.clientY;
      }
    },

    onCueingTouchEnd(e) {
      e.currentTarget.style.pointerEvents = '';
      this._cDecided = false;
      this._cIsVertical = false;
      if (this._cRafId) {
        cancelAnimationFrame(this._cRafId);
        this._cRafId = null;
      }
    },


    resizeCueingIframe() {
      const iframe = this.$refs.cueingIframe;
      if (!iframe) return;

      const setHeight = () => {
        try {
          const doc = iframe.contentDocument;
          if (!doc || !doc.body || !doc.documentElement) return;

          const body = doc.body;
          const html = doc.documentElement;

          const height = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.scrollHeight,
            html.offsetHeight,
            html.clientHeight,
            600
          );

          iframe.style.height = `${height}px`;
        } catch (e) {
          // same-origin이 아니면 접근 실패할 수 있으나 현재는 proxy 사용
        }
      };

      setHeight();
      requestAnimationFrame(setHeight);
      this.$nextTick(() => setHeight());

      setTimeout(setHeight, 300);
      setTimeout(setHeight, 800);
      setTimeout(setHeight, 1500);
      setTimeout(setHeight, 2500);

      try {
        const doc = iframe.contentDocument;
        if (!doc || !doc.body || !doc.documentElement) return;

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        this.resizeObserver = new ResizeObserver(() => {
          setHeight();
        });

        this.resizeObserver.observe(doc.body);
        this.resizeObserver.observe(doc.documentElement);

        const imgs = doc.querySelectorAll('img');
        imgs.forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', setHeight, { once: true });
            img.addEventListener('error', setHeight, { once: true });
          }
        });

        doc.addEventListener('click', () => {
          setTimeout(setHeight, 100);
          setTimeout(setHeight, 400);
        });
      } catch (e) {
        console.log('iframe resize observer 등록 오류:', e);
      }
    },

    async getProductDetail_new() {
      let productDetail = [];
      productDetail = await this.$api('/api/productDetail_new', {
        param: [this.productId]
      });

      if (productDetail.length > 0) {
        this.productDetail = productDetail[0];
        this.tripProp = this.productDetail.tripProp;
        this.quillFlag = this.productDetail.quillFlag;
        this.jointFlag = this.productDetail.jointFlag;
      }

      this.getProductImage();
      this.getProductDetailImage();
      this.getProductTransInfoExited();
      this.getReviewList();
      this.getProductPrice_new();

      if (this.productDetail.cueingFlag === 'Y' && this.productDetail.cueingUrl) {
        this.cueingUrl = `/api/cueingProxy?url=${encodeURIComponent(this.productDetail.cueingUrl)}`;
      }
    },

    async getProductPrice_new() {
      let detailPrice = await this.$api("/api/pdtDetailminPrice_new", {param: [ this.productId, this.productId ]});
      
      if(detailPrice.length > 0) 
      {
        this.detailPrice = detailPrice;
        this.pdt_basicPrice = detailPrice[0].basic_PdtPrice
        this.pdt_minPrice = detailPrice[0].basic_PdtPrice + detailPrice[0].minOptPrice
        this.osCode = detailPrice[0].osCode;
        this.prcCode = detailPrice[0].prcCode;
        this.dTypeFlag = detailPrice[0].dTypeFlag;
        this.addPdtFlag = detailPrice[0].addProduct_flag;
        if(this.dTypeFlag == 'N') 
        {
          this.getPdtPriceForCalendar_new_noDateType(this.pdt_basicPrice, this.osCode);
        } 
        else 
        {
          await this.getPdtPriceForCalendar_new(this.pdt_basicPrice, this.osCode);
          this.getFirstAvailableDate();
        }
        
        if (this.addPdtFlag === 'Y') 
        {
          let addCode = await this.$api("/api/getAddCode", {param: [ this.prcCode ]});

          if (addCode && addCode.length > 0) 
          {
            this.addCode = addCode[0].addCode;
            let addProductInfo = await this.$api("/api/addProductInfo", {param: [ this.addCode, this.prcCode ]});
            this.addPdtInfo = (addProductInfo && addProductInfo.length > 0) ? addProductInfo : [];
          } 
          else 
          { 
            this.addPdtInfo = [];
            console.warn('[추가상품] 추가상품코드 없음:', this.prcCode);
          }
        }
      }
    },
    async getCanBuy() {
      let canBuy = await this.$api("/api/canBuyCheck", {param: [this.productId]});
      console.log("canBuy:", canBuy)
    },
    async getPdtPriceForCalendar_new_noDateType(bsPrice, osCode) {
      let calPdtPrice = [];
      calPdtPrice = await this.$api("/api/calPdtPriceNew_new_nonDType", {param: [ bsPrice, osCode ]});
      this.inquiryFlag = 'Y'
      this.calPdtPrice = calPdtPrice;
      this.priceData = calPdtPrice;
      let selectedCalPdtPrice = await this.$api("/api/selectedOptInfoForNoneDateType", {param: [ this.pdt_basicPrice, this.osCode]});
      if(selectedCalPdtPrice.length > 0) { this.selectedCalPdtPrice = selectedCalPdtPrice; this.selOptFlag = "Y"; }
      let dirOptInfo = await this.$api("/api/get_directOption_info", {param:[ this.productId ]});
      if(dirOptInfo.length > 0) { this.dirOptFlag = "Y"; this.dirOptInfo = dirOptInfo; }
    },
    async getPdtPriceForCalendar_new(bsPrice, osCode) {
      let calPdtPrice = [];
      calPdtPrice = await this.$api("/api/calPdtPriceNew_new", {param: [ bsPrice, osCode ]});
      let calPdtPrice_min = [];
      calPdtPrice_min = await this.$api("/api/calPdtPriceNew_new_min", {param: [ bsPrice, osCode ]});
      this.calPdtPrice = calPdtPrice
      let priceData = {};
      priceData = calPdtPrice_min.reduce((obj, item) => {
        if(item.sellStatus != 'Y' || item.osQty == 0) { obj[item.saleDate] = null; }
        else { obj[item.saleDate] = item.pdtPrice_org_min }
        return obj;
      }, {});
      this.priceData = priceData;
    },
    
    selectDate_new(date) {
      if (!date) return;       // 달력 빈칸 클릭      
      this.initializeCounts()
      this.inquiryFlag = 'N'
      let selectedDate = date;
      this.selectedDate = moment(selectedDate).format('YYYY-MM-DD')
      this.selectedPrice = this.getPrice(date.format('YYYY-MM-DD'));
      if (this.selectedPrice > 0) { this.selDate_new_new(this.selectedDate); }
    },

    async selDate_new_new(selDate) {
      this.inquiryFlag = 'Y';
      this.reqRtnDate = "";
      this.selectedCalPdtPrice = [];        // 이전 날짜 옵션 즉시 제거

      if (this.productDetail.tripProp === "D") 
      {
        const raw = this.productDetail.stayCnt;
        const stayCnt = (raw === null || raw === undefined || raw === '') ? NaN : Number(raw);
        const selecDate_tmp = new Date(selDate);
        let reqRtnDate_tmp;

        if (stayCnt === 0) 
        {
          reqRtnDate_tmp = new Date(selecDate_tmp);
        } 
        else if (stayCnt > 0) 
        {
          reqRtnDate_tmp = new Date(selecDate_tmp.setDate(selecDate_tmp.getDate() + (stayCnt - 1)));
        } 
        else 
        { 
          this.$swal.fire('', '날짜선택에 오류가 발생했습니다.<br>담당자에 문의하여 주십시오.', 'error'); 
          return false; 
        }
        this.reqRtnDate = this.getDateFormat(reqRtnDate_tmp);
      }

      const selectedCalPdtPrice = await this.$api("/api/selectedDatePrice", {param: [ this.pdt_basicPrice, this.osCode, selDate ]});

      // 응답 대기 중 다른 날짜를 선택(또는 월 이동)했으면 이 응답은 폐기
      if (selDate !== this.selectedDate) return;

      this.selectedCalPdtPrice = Array.isArray(selectedCalPdtPrice) ? selectedCalPdtPrice : [];

      const selOptFlag = this.selectedCalPdtPrice.some(item => 
        item.os3 !== null && item.os3 !== undefined && item.os3 !== '' && 
        item.pdtPrice_org * 1 > 0 && item.sellStatus === 'Y' && item.osQty * 1 > 0
      );
      this.selOptFlag = selOptFlag ? 'Y' : 'N';

      const dirOptInfo = await this.$api("/api/get_directOption_info", {param: [ this.productId ]});
      if (selDate !== this.selectedDate) return;

      if (Array.isArray(dirOptInfo) && dirOptInfo.length > 0) 
      { 
        this.dirOptFlag = "Y"; 
        this.dirOptInfo = dirOptInfo; 
      }
    },

    // 옵션, 추가상품 카운트
    numCount(val, param, selOptName) {
      let item, maxQty;

      if (val === 'opt') 
      {
        item = this.rsvData_temp.find(i => i.selOptName === selOptName);
        const selectedOpt = this.selectedCalPdtPrice.find(opt => opt.os3 === selOptName || opt.os1 === selOptName);
        maxQty = selectedOpt ? Number(selectedOpt.osQty) : Infinity;
      } 
      else if (val === 'add') 
      {
        item = this.rsvData_temp.find(i => i.addSeq === selOptName);
        // 추가상품의 최대 수량을 가져오기 위해 addPdtInfo 배열에서 해당 추가상품검색
        const selectedAddProduct = this.addPdtInfo.find(ap => ap.addSeq == selOptName);
        maxQty = selectedAddProduct ? Number(selectedAddProduct.addQty) : Infinity;
      } 
      else 
      {
        return;
      }

      if (!item) return;

      if (param === 'P') 
      {
        if ((item.count || 0) < maxQty) 
        {
          item.count = (item.count || 0) + 1;
        } 
        else 
        {
          this.$swal.fire('', `"${selOptName}" 옵션은 최대 ${maxQty}개까지 구매 가능합니다.`, 'warning');
        }
      } 
      else if (param === 'M') 
      {
        if ((item.count || 0) > 0) item.count = (item.count || 0) - 1;
      }
    },

    // 삭제 후, 드롭다운 초기화
    deletePrice(param, sOptName) {
      if (param == 'opt') 
      { 
        this.rsvData_temp = this.rsvData_temp.filter(item => item.selOptName !== sOptName); 
        this.choicedSelOpt = 'noVal';
      }
      if (param == 'add') 
      { 
        this.rsvData_temp = this.rsvData_temp.filter(item => item.addSeq !== sOptName); 
        this.choicedAddPdt = 'noVal';
      }
    },

    scrollToPosition(param) {
      const element = document.getElementById(param);
      if (element) { element.scrollIntoView({ behavior: 'smooth' }); }
    },
    toggle(optCode) {
      if(this.selectedOptions[optCode]) { this.selectedOptions[optCode] = false }
      else { this.selectedOptions[optCode] = true }
      this.$nextTick(() => { this.scrollToSection(); });
    },
    closeModal2() { this.showModal2 = false },
    toggleModal() { this.showModal2 = true },
    showPopupOnRefresh(event) {
      if (this.noPopFlag == 'N') {
        const message = '페이지 새로고침을 하시겠습니까?작성 중 내용이 지워지게 됩니다.'
        event.returnValue = message
      }
    },
    async showPopupOnBack() {
      const message = '이 페이지에서 나가시겠습니까?<br>작성 중 내용이 지워지게 됩니다.'
      const result = await this.$swal.fire({ title: '', html: message, icon: 'question', showCancelButton: true, confirmButtonText: '네', cancelButtonText: '아니요' })
      if (result.isConfirmed) { this.inquiryFlag = 'N'; return true } else { return false }
    },
    changeReview(rvCode, nSeq, iSeq) {
      this.$router.push({path: '/reviewModify', query: {rvCode: rvCode, nSeq: nSeq, iSeq: iSeq}});
    },

    formatManCurrency(amount) {
      const n = Number(amount);
      if (!isFinite(n) || n <= 0) return '-';

      const man = n / 10000;

      // 100만원 이상: 정수 만원 단위 (예: 139, 1,349)
      if (man >= 100) {
        return Math.floor(man).toLocaleString('ko-KR');
      }

      // 100만원 미만: 소수 첫째 자리까지 (예: 35.5, 0.5)
      return (Math.round(man * 10) / 10).toLocaleString('ko-KR', { maximumFractionDigits: 1 });
    },

    async getFirstAvailableDate() {
      if(this.dTypeFlag != "Y") { return; }
      const firstAvailableDate = Object.keys(this.priceData).find(date => this.priceData[date] !== null);
      if (firstAvailableDate) { this.currentDate = moment(firstAvailableDate).startOf('month'); }
      else { this.goToCurrentMonth(); }
    },
    async getReviewList() {
      let reviewList = await this.$api("/api/reviewList", {param: [this.productId]});
      if(reviewList.length > 0) { this.reviewList = reviewList }
    },
    previousMonth() { this.inquiryFlag = "N"; this.currentDate = this.currentDate.clone().subtract(1, 'month'); this.selectedDate = null; },
    nextMonth() { this.inquiryFlag = "N"; this.currentDate = this.currentDate.clone().add(1, 'month'); this.selectedDate = null; },
    goToCurrentMonth() { this.inquiryFlag = "N"; const today = moment(); this.currentDate = moment([today.year(), today.month(), today.date()]); this.selectedDate = null; },
    getPrice(date) {
      if (!this.priceData) { this.getPdtPriceForCalendar_new() }
      if (date in this.priceData) { return Number(this.priceData[date]); }
      else { return null }
    },
    isToday(date) { return moment().isSame(date, 'day'); },
    isSelected(date) {
      if (!this.selectedDate) { return false; }
      else if (moment(this.selectedDate).isSame(date, 'day')) { return true; }
      else { return false; }
    },
    goTo(id) {
      var element = document.getElementById(id);
      if (element) { element.scrollIntoView({ behavior: 'smooth' }); }
      else { console.error('Element with the specified ID not found'); }
    },
    showFlag() { this.rShowFlag = (this.rShowFlag == 'Y') ? 'N' : 'Y' },
    scrollToId(id) {
      const element = document.getElementById(id);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition, behavior: 'smooth' });
      }
    },
    async getProductTransInfoExited() {
      let pdtTransInfo1 = await this.$api("/api/pdtTransInfo_existed", {param: [this.productId]});
      if(pdtTransInfo1.length > 0) { this.pdtTransInfo1 = pdtTransInfo1[0]; }
    },

    // 상단 캐러셀이 지정된 순서대로 보여지도록 처리
    async getProductImage() {
      const productImage = await this.$api("/api/productImage_carousel", {param: [this.productId]});
      this.productImage = Array.isArray(productImage) ? productImage : [];
    },
    // async getProductImage() {
    //   let productImage = await this.$api("/api/productImage", {param: [this.productId]});
    //   this.productImage = (productImage.length > 0) ? productImage : "";
    // },
    async getProductDetailImage() {
      if(this.quillFlag === "Y") {
        try {
          let response = await axios.get(`/uploads/${this.productId}/${this.filename}`);
          if (response.data.success) { this.renderedHtml = response.data.content; }
          else { throw new Error('Failed to load document'); }
        } catch (error) { this.$swal.fire('', '에디팅된 상세페이지가 없습니다', 'info'); }
      } else {
        let productDetailImage = await this.$api("/api/productDetailImage_new", {param: [this.productId]});
        this.productDetailImage = (productDetailImage.length > 0) ? productDetailImage : "";
      }
    },
    inquiryProduct() {
      this.$router.push({path: '/inquiryProduct', query: {productId: this.productId, salesRoute:this.productDetail.salesRoute}});
    },
    async genCode(param) {
      let chkFlag = "N";
      let rtnCode = "";
      for (let attempts = 0; attempts < 1000 && chkFlag === "N"; attempts++) {
        let today = new Date();
        let yy = today.getFullYear().toString().slice(-2);
        let mm = today.getMonth() + 1;
        let dd = today.getDate();
        let ymd = `${yy}${mm}${dd}`;
        let dCd = param + ymd;
        rtnCode = await genCode(this.$api, dCd);
        let chk_genCode = await this.$api("/api/checkDub_resCode", { param: [rtnCode] });
        if (chk_genCode.length > 0) { chkFlag = "N"; } else { chkFlag = "Y"; }
      }
      if (chkFlag === "N") { this.$swal.fire("","예약번호 생성횟수 한계에 도달하였습니다.<br>담당자에게 문의(1660-4602)하여 주세요.","warning"); return false; }
      else { return rtnCode }
    },
    
    async orderCheck_new(flag) {
      if (this.blockedReservation()) return false;     // [임시] 예약차단 - 정규화 시 제거

      // 1) 선택요건 검증 - 로그인/비회원 팝업보다 먼저 실행
      if (!this.validateReservation()) return false;

      // 2) 추가상품 미선택 확인 (선택 가능한 추가상품이 있는 상품만)
      const hasSelectedAdd = this.rsvData_temp.some(item => item.addSeq != null && item.addSeq !== '');
      if (this.addPdtFlag === 'Y' && this.hasAddPdt && !hasSelectedAdd) 
      {
        const result = await this.$swal.fire({
          html: '선택하신 추가상품이 없습니다.<br>추가상품 없이 예약을 진행하시겠습니까?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: '예약 진행',
          cancelButtonText: '추가상품 선택',
          reverseButtons: true
        });
        if (!result.isConfirmed) return false;     // 모바일 모달은 열린 채 유지 → 바로 추가상품 선택 가능
      }

      // 쿠폰 적용은 "구매수량/총액" 기준이 아니라, 선택된 옵션 중 단가가 가장 높은 1건 기준으로만 적용됨(추가상품포함)
      // (회사 정책: 여러 상품을 구매해도 쿠폰 할인은 대표 1인분에만 반영)
      let priceForCoupon = this.rsvData_temp.filter(item => item.count >= 1).reduce((max, item) => { return item.pdtPrice > max ? item.pdtPrice : max }, 0)
      this.priceForCoupon = priceForCoupon
      this.memDCAmt = 0

      // 멤버십 기본할인 (엔데이트립 N / 멤버십플러스 PS) + 공동모객 상품 제외 - 20261023
      const isMember = ["N", "PS"].includes(this.user.memLevel)
      const isJoint  = this.jointFlag && this.jointFlag !== "N"

      if(isMember && !isJoint) 
      {
        this.memDCAmt = this.priceForCoupon * (this.memDCRate / 100)
        this.priceForCoupon = this.priceForCoupon - this.memDCAmt
      }
      this.showModal2 = false
      console.log(flag+'21K23!98h40D')
      
      if(this.userInfo == undefined || this.userInfo == "" || !this.userInfo) 
      {
        this.$swal.fire({ 
          html: "엔타비글로벌여행사를 이용해주셔서 감사합니다<br>회원이신 경우, 로그인 후 진행하여 주십시오.<br>비회원이신 경우, 회원가입 또는 비회원으로 예약진행이 가능합니다.", 
          showCancelButton: false, 
          showDenyButton: true, 
          confirmButtonText: "로그인 페이지로 이동", 
          denyButtonText: "비회원으로 예약진행", 
          imageUrl: '/IMGs/welcome.png', imageWidth: 400, imageHeight: 200 })
        .then((result) => {
          if(result.isConfirmed) 
          { 
            this.$router.push({path: '/b2CLogin', query:{
              st: "Y",
              redirect: this.$route.fullPath      //리다이렉트 후 다시 돌아올 경로
            }});
        }
          else if(result.isDenied) { this.memberFlag = "N"; this.order_new(flag) }
        })
      } 
      else 
      { this.order_new(flag) }
    },

    // 중복클릭 방지 래퍼
    async order_new(flag) {
      if (this.isOrdering) return false;
      this.isOrdering = true;
      try {
        return await this.order_new_body(flag);
      } finally {
        this.isOrdering = false;
      }
    },

    async order_new_body(flag) {
      if (this.blockedReservation()) return false;     // [임시] 예약차단 - 비회원 경로(.then) 대비 최종방어, 정규화 시 제거

      // 최종 방어선: 비회원 경로 등으로 진입해도 선택요건 재검증
      if (!this.validateReservation()) return false;

      // $api는 에러 시 throw하지 않고 {error}를 반환 → 반환값으로 성공/실패 판정
      const fail = (label, res) => {
        console.error(`[${label} 등록실패]`, res?.error);
        this.$swal.fire("", `${label}의 예약등록에 실패했습니다. 재진행을 부탁드립니다.<br>반복오류 발생 시, 문의처(1566-4602)`, "error");
        return false;
      };

      const optItems = this.rsvData_temp.filter(item => item.selOptName != null && item.selOptName !== "");
      // 추가상품: 선택사항 / 복수선택 (수량 0개는 validateReservation에서 이미 차단됨)
      const addItems = this.rsvData_temp.filter(item => item.addSeq != null && item.addSeq !== "");

      const totalCount = [...optItems, ...addItems].reduce((sum, item) => sum + (item.count ?? 0), 0);
      if (totalCount < 1) {
        this.$swal.fire("", "구입상품수를 확인해주세요", "warning");
        return false;
      }

      if (this.totalPrice === undefined || !(this.totalPrice > 0) || this.productDetail.pdtCode === undefined) {
        this.$swal.fire("", "예약진행 중 오류가 있습니다.<br>확인 후 재신청하여 주십시오", "warning");
        return false;
      }

      // 예약번호 생성 (모든 검증 통과 후)
      const catCode = "RQ-" + this.salesRoute;
      const reqReserveCode = await this.genCode(catCode);
      if (!reqReserveCode) return false;     // genCode는 실패 시 false 반환
      this.reqReserveCode = reqReserveCode;
      console.log("flag1:", flag + '21K23!98h40D');

      this.reqRtnDate = (this.reqRtnDate == "") ? null : this.reqRtnDate;
      const reqPdtPriceFin = Math.round(Number(this.totalPrice));

      const rCopyFlag = "N";
      const reqStatus = "IQ";
      const completeFlag = "N";
      const newResFlag = "Y";
      const memShip = this.user.memLevel == undefined ? "" : this.user.memLevel;
      const VAT_PRICE = 0;   // 영세율 적용업종 - 부가세 항상 0원(회사 전체 정책)

      // 1. 예약 마스터
      const resM = await this.$api("/api/proc_insReserve_m_new_new_new", {param: [
        this.reqReserveCode, this.productId, reqStatus, this.selectedDate, VAT_PRICE,
        this.reqRtnDate, this.tripProp, this.productDetail.stayCnt, reqPdtPriceFin, reqPdtPriceFin,
        rCopyFlag, this.productDetail.ctCd, completeFlag, this.productDetail.nrFlag, this.productDetail.vrFlag,
        this.memberFlag, newResFlag, totalCount, reqPdtPriceFin, this.dirOptFlag,
        this.selOptFlag, this.addPdtFlag, this.priceForCoupon, this.memDCAmt, memShip
      ]});

      if (!resM || resM.error || resM.affectedRows === undefined || resM.affectedRows < 0) {
        this.$swal.fire('', '<b class="text-danger">죄송합니다</b><br>처리 중 문제가 발생했습니다.(' + (resM?.error?.sqlMessage ?? '알 수 없는 오류') + ')', 'warning');
        return false;
      }

      // 2. 선택옵션
      if (this.selOptFlag === "Y") {
        for (const item of optItems) {
          const res = await this.$api("/api/proc_insReserve_opt_new", {param: [
            this.reqReserveCode, this.productId, this.osCode, item.selOptName, item.count,
            "Y",          // optUseFlag
            "N",          // optCompFlag
            item.pdtPrice,
            "N",          // osUpdateFlag_M
            item.osSeq,
            "N"           // osUpdateFlag_P
          ]});
          if (!res || res.error) return fail("선택옵션", res);
        }
      }

      // 3. 직접입력형 옵션
      if (this.dirOptFlag === "Y") {
        for (const od of this.dirOptInfo) {
          const res = await this.$api("/api/proc_insReserve_dirOpt_new", {param: [
            this.reqReserveCode, this.productId,
            "Y",          // dirUseFlag
            "N",          // dirCompFlag
            od.odCode, od.odName, String(od.odValue ?? '').trim()
          ]});
          if (!res || res.error) return fail("직접형 옵션", res);
        }
      }

      // 4. 추가상품 (선택한 경우에만)
      if (this.addPdtFlag === "Y" && addItems.length > 0) {
        for (const item of addItems) {
          const res = await this.$api("/api/proc_insReserve_addpdt", {param: [
            this.reqReserveCode, this.productId, this.addCode, item.addPdtName, item.addPdtValue,
            item.pdtPrice, item.count,
            "Y",          // addUseFlag
            "N",          // addCompFlag
            "N",          // addUpdateFlag_M
            item.addSeq,
            "N"           // addUpdateFlag_P
          ]});
          if (!res || res.error) return fail("추가상품", res);
        }
      }

      // 5. 완료 → 이동 직전에만 이탈팝업 해제
      this.noPopFlag = "Y";
      this.$router.push({path: "/reservation", query: { resCode: this.reqReserveCode, prodId: this.productId }});
    },
  }
}
</script>

<style scoped>
@import "../assets/css/style.css";

/* ================================================
  # CSS 변수 + 최상위 (scoped 안에서 #product에 선언 → 하위 전체 상속, 타 페이지 영향 없음)
================================================ */
#product {
  --ci-green: #86cd53;
  --ci-green-dark: #6ab53e;
  --ci-green-light: #e8f7dc;
  --charcoal: #1c1c1c;
  --charcoal-soft: #2d2d2d;
  --crimsonbar: #b61135cb;
  --gray-100: #f8f9f5;
  --gray-200: #ededea;
  --gray-400: #aaa;
  --gray-600: #666;
  --text-main: #1c1c1c;
  --text-sub: #555;
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 18px;
  --shadow-sm: 0 2px 8px rgba(0,0,0,0.07);
  --shadow-md: 0 6px 24px rgba(0,0,0,0.10);

  margin-top: 4rem;
  background-color: #fdfdfc;
}

#recent-item { display: none; }


/* ================================================
  # 왼쪽 영역
================================================ */
#product .pr-left {
  padding-right: 1.5rem;
}
@media (max-width: 991px) {
  #product .pr-left { padding-right: 0; }
}


/* ---- 타이틀 ---- */
#product .pr-left .section-tittle {
  margin: 2.5rem 0 1.5rem;
  padding-left: 0;
}
.title-accent-line {
  width: 48px;
  height: 4px;
  background: var(--ci-green);
  border-radius: 2px;
  margin-bottom: 1rem;
}
#product .pr-left .section-tittle h2 {
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--charcoal);
  letter-spacing: -0.5px;
  margin-bottom: 0.4rem;
}
.pdt-remarks {
  font-size: 0.88rem;
  color: var(--gray-600);
  padding-left: 2px;
  margin: 0;
}
@media (max-width: 575px) {
  #product .pr-left .section-tittle h2 { font-size: 1.35rem; }
}


/* ---- 캐러셀 ---- */
.carousel-wrap {
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-md);
}
#product .pr-left .carousel-inner img {
  height: 480px;
  object-fit: cover;
}
@media (max-width: 991px) {
  #product .pr-left .carousel-inner img { height: 300px; }
}


/* ---- 상품번호 ---- */
.pdt-code-wrap {
  margin-top: 0.8rem;
  margin-bottom: 0.5rem;
}
.pdt-code-badge {
  display: inline-block;
  font-size: 0.75rem;
  color: var(--gray-600);
  background: var(--gray-200);
  border-radius: 20px;
  padding: 2px 12px;
  letter-spacing: 0.5px;
}


/* ---- 교통편 / 체크포인트 ---- */
.vech-wrap {
  margin-top: 2.5rem;
}
.vech-title {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--ci-green-dark);
  margin-bottom: 0.6rem;
}
.vech-table {
  border-top: 2px solid var(--charcoal);
}
.vech-table .stand {
  background-color: var(--gray-100);
  color: var(--charcoal);
  font-size: 0.9rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 2px;
  width: 90px;
  vertical-align: middle;
  border-right: 1px solid var(--gray-200);
}
.vech-table .stand.check {
  color: #b54a4a;
  line-height: 1.3;
  letter-spacing: 0;
}
.vech-table .sub {
  padding: 0.9rem 0 0.9rem 1.2rem;
  font-size: 0.92rem;
  color: var(--text-sub);
  vertical-align: middle;
}
.checkpoint-row .sub small { color: var(--text-sub); }
.trans-label { font-weight: 600; color: var(--charcoal); }
.trans-none { color: var(--gray-400); }
.trans-name { font-weight: 700; font-size: 1rem; color: var(--charcoal); }
.trans-route { color: var(--text-sub); margin-left: 6px; }
.trans-remark { color: var(--gray-400); font-size: 0.82rem; }

@media (max-width: 991px) {
  .vech-table .stand { width: 70px; font-size: 0.82rem; letter-spacing: 0; }
  .vech-table .sub { font-size: 0.85rem; padding: 0.7rem 0 0.7rem 0.6rem; }
}


/* ---- 포함 / 불포함 ---- */
.in-non-wrap {
  margin-top: 4rem;
}
.in-non-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 575px) {
  .in-non-grid { grid-template-columns: 1fr; }
}
.in-non-card {
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--gray-200);
}
.in-non-header {
  padding: 0.7rem 1.2rem;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.include-header {
  background-color: var(--ci-green-light);
  color: var(--ci-green-dark);
  border-bottom: 1px solid #c8e9a4;
}
.exclude-header {
  background-color: #fff0f0;
  color: #b54a4a;
  border-bottom: 1px solid #f0c4c4;
}
.in-non-body {
  padding: 1rem 1.2rem;
  font-size: 0.88rem;
  color: var(--text-sub);
  background: #fff;
  word-wrap: break-word;
  white-space: pre-wrap;
  margin: 0;
}


/* ---- 카테고리 탭 ---- */
#product .pr-left .category {
  margin: 6rem 0;
}
#product .pr-left .category .clist {
  margin: 3.5rem 0;
  border-bottom: 2px solid var(--charcoal);
  padding-bottom: 0;
}
#product .pr-left .category .nav-tabs {
  border: none;
  gap: 0;
}
#product .pr-left .category ul li {
  display: inline-block;
  margin-right: 0;
}
#product .pr-left .category .nav-link {
  border: none;
  color: var(--gray-400);
  padding: 0.6rem 1.2rem 0.8rem;
  background: none;
  position: relative;
  display: block;
  text-decoration: none;
}
#product .pr-left .category .nav-item span {
  font-size: 1.05rem;
  font-weight: 600;
  display: block;
  transition: color 0.2s;
}
#product .pr-left .category .nav-link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 3px;
  background: var(--ci-green);
  border-radius: 2px 2px 0 0;
  transition: width 0.25s ease;
}
#product .pr-left .category .nav-link:hover::after,
#product .pr-left .category .nav-link.active::after,
#product .pr-left .category .nav-link.active.show::after {
  width: 100%;
}
#product .pr-left .category .nav-link:hover span { color: var(--charcoal); }
#product .pr-left .category .nav-tabs .nav-link.active span,
#product .pr-left .category .nav-tabs .nav-link.active.show span {
  color: var(--charcoal);
}

@media (max-width: 767px) {
  #product .pr-left .category .nav-link { padding: 0.5rem 0.6rem 0.7rem; }
  #product .pr-left .category .nav-item span { font-size: 0.88rem; }
}
@media (max-width: 453px) {
  #product .pr-left .category .nav-link { padding: 0.4rem 0.4rem 0.6rem; }
  #product .pr-left .category .nav-item span { font-size: 0.78rem; }
}


/* ---- 탭 콘텐츠 (안내/취소) ---- */
.tab-section-inner {
  text-align: left;
  padding: 0 0.5rem;
}
.tab-section-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--charcoal);
  margin-bottom: 1rem;
  padding-bottom: 0.6rem;
  border-bottom: 2px solid var(--ci-green);
  display: inline-block;
}
.tab-pre-content {
  font-size: 0.9rem;
  color: var(--text-sub);
  word-wrap: break-word;
  white-space: pre-wrap;
  background: var(--gray-100);
  border-radius: var(--radius-sm);
  padding: 1.2rem 1.4rem;
  border-left: 3px solid var(--gray-200);
}


/* ---- 이용후기 ---- */
#product .pr-left .category .creview .tab-section-title { margin-bottom: 0; }
.review-divider {
  height: 1px;
  background: var(--gray-200);
  margin: 1rem 0 2rem;
}
.review-item {
  display: flex;
  gap: 1.5rem;
  padding: 1.5rem 0;
  border-bottom: 1px solid var(--gray-200);
  align-items: flex-start;
}
.review-img-wrap { flex-shrink: 0; }
.review-img {
  width: 200px;
  height: 160px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
}
.review-content { flex: 1; }
.review-top { margin-bottom: 0.3rem; }
.reviewt { font-size: 1.15rem; font-weight: 700; color: var(--charcoal); }
.btn-review-edit {
  font-size: 0.75rem;
  border: 1px solid var(--gray-400);
  background: none;
  border-radius: 4px;
  padding: 2px 8px;
  color: var(--gray-600);
  cursor: pointer;
  margin-left: 6px;
  transition: all 0.2s;
}
.btn-review-edit:hover { background: var(--gray-200); }
.reviewn { font-size: 0.78rem; color: var(--gray-400); margin-bottom: 0.6rem; display: flex; gap: 0.8rem; align-items: center; }
.review-name { font-weight: 600; }
.review-date { }
.review-body { font-size: 0.9rem; color: var(--text-sub); word-wrap: break-word; white-space: pre-wrap; margin: 0; }
.review-empty { text-align: center; padding: 3rem 0; color: var(--gray-400); }
.review-empty i { font-size: 2.5rem; display: block; margin-bottom: 0.8rem; }
.review-empty p { margin: 0; font-size: 0.9rem; }

@media (max-width: 767px) {
  .review-item { flex-direction: column; gap: 1rem; }
  .review-img { width: 100%; height: 200px; }
}


/* ================================================
  # 오른쪽 사이드바
================================================ */
#product .pr-right {
  position: sticky;
  top: 1rem;
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
  background: #fff;
  box-shadow: var(--shadow-md);
  overflow: hidden;
  width: 100%;
  max-width: 22rem;
}
@media (max-width: 991px) {
  #product .pr-right { display: none; }
}


/* ---- 달력 헤더 ---- */
#product .pr-right .calendar { width: 100%; }
#product .pr-right .calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--charcoal);
  padding: 0.7rem 1rem;
}
#product .pr-right .calendar-header-date {
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
}
#product .pr-right .calendarbtn {
  border: none;
  background: transparent;
  color: var(--ci-green);
  font-size: 1rem;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.15s;
  cursor: pointer;
}
#product .pr-right .calendarbtn:hover { background: rgba(255,255,255,0.1); }


/* ---- 달력 바디 ---- */
#product .pr-right .calendar-body { padding: 0.5rem 0.75rem; }
.cal-header-row { margin-bottom: 2px; }
#product .pr-right .calendar-row { display: flex; }
#product .pr-right .calendar-day-header {
  width: calc(100% / 7);
  text-align: center;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--gray-600);
  padding: 4px 0;
}
#product .pr-right .calendar-day {
  width: calc(100% / 7);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3px 1px;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: background 0.15s;
}
#product .pr-right .calendar-day:hover { background: var(--ci-green-light); }
#product .pr-right .calendar-date {
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--text-main);
  line-height: 1.4;
}
#product .pr-right .calendar-day.today .calendar-date {
  background: var(--ci-green);
  color: #fff;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border: none;
}
#product .pr-right .calendar-day.selected {
  background: var(--ci-green-light);
}
#product .pr-right .calendar-day.selected .calendar-date {
  color: var(--ci-green-dark);
  font-weight: 700;
}
#product .pr-right .calendar-price {
  font-size: 0.65rem;
  color: var(--ci-green-dark);
  font-weight: 600;
  margin-top: 1px;
}
.price-unit { font-size: 0.6rem; color: var(--gray-400); margin-left: 1px; }


/* ---- 사이드바 구분선 ---- */
.sidebar-divider {
  height: 1px;
  background: var(--gray-200);
  margin: 0.6rem 1rem;
}


/* ---- 선택된 날짜 배지 ---- */
.selected-date-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--ci-green-light);
  color: var(--ci-green-dark);
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  margin: 0.5rem 0;
}


/* ---- 옵션 선택 ---- */
#product .pr-right .price { padding: 0.3rem 0.75rem 0.5rem; }
#product .pr-right .price table { width: 100%; }
.opt-label {
  font-size: 0.75rem;
  color: var(--gray-400);
  margin-bottom: 4px;
  margin-top: 6px;
}
.opt-input {
  width: 100%;
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-sm);
  padding: 7px 10px;
  font-size: 0.88rem;
  color: var(--text-main);
  outline: none;
  transition: border-color 0.2s;
}
.opt-input:focus { border-color: var(--ci-green); }
.opt-input::placeholder { color: #ccc; font-size: 0.82rem; }
.opt-select-wrap {
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-sm);
  overflow: hidden;
  transition: border-color 0.2s;
}
.opt-select-wrap:focus-within { border-color: var(--ci-green); }
.opt-select {
  width: 100%;
  border: none;
  padding: 7px 10px;
  font-size: 0.85rem;
  color: var(--text-main);
  background: #fff;
  outline: none;
  cursor: pointer;
}


/* ---- 비달력형 상품 ---- */
.noncal-pdt-info { padding: 1rem 1rem 0.5rem; }
.noncal-pdt-name { font-size: 0.95rem; font-weight: 600; color: var(--charcoal); margin-bottom: 0.5rem; }
.noncal-price { display: flex; justify-content: space-between; align-items: center; margin: 0; padding: 4px 0; }
.noncal-opt-name { font-size: 0.85rem; color: var(--text-sub); }
.noncal-price-val { font-size: 0.95rem; font-weight: 700; color: #c0392b; }


/* ---- 가격 계산 ---- */
#product .pr-right .total-P { padding: 0 0.75rem; }
#product .pr-right .total-P table { width: 100%; }
.price-row-td {
  width: 100%;
  font-size: 0.82rem;
  padding: 0.5rem 0;
}
.price-opt-info {
  color: var(--gray-400);
  word-break: break-all;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}
.price-delete-btn {
  color: #e74c3c;
  cursor: pointer;
  font-size: 0.9rem;
  margin-left: auto;
  flex-shrink: 0;
}
.price-count-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem 0 0.6rem;
}
.count-group {
  display: flex;
  align-items: center;
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-sm);
  overflow: hidden;
}
.count-btn {
  border: none;
  background: var(--gray-100);
  padding: 6px 10px;
  cursor: pointer;
  font-size: 0.9rem;
  color: var(--charcoal);
  transition: background 0.15s;
}
.count-btn.minus:hover { background: #fde8e8; color: #e74c3c; }
.count-btn.plus:hover { background: var(--ci-green-light); color: var(--ci-green-dark); }
.count-num {
  padding: 0 14px;
  font-size: 1.05rem;
  font-weight: 700;
  min-width: 44px;
  text-align: center;
  border-left: 1px solid var(--gray-200);
  border-right: 1px solid var(--gray-200);
  color: var(--charcoal);
}
.price-amount {
  text-align: right;
}
.price-amount b { font-size: 1.1rem; font-weight: 700; color: var(--charcoal); }
.price-unit-won { font-size: 0.82rem; color: var(--gray-400); margin-left: 2px; }


/* ---- 총액 ---- */
.total-price-td { padding: 0.7rem 0; }
.total-price-wrap {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.3rem 0;
}
.total-label { font-size: 0.85rem; color: var(--gray-400); }
.total-amount { font-size: 1.6rem; font-weight: 800; color: var(--charcoal); }
.total-won { font-size: 0.9rem; color: var(--gray-400); margin-left: 2px; }


/* ---- 예약하기 버튼 ---- */
#product .pr-right .pr-go { margin: 0.5rem 0 0.8rem; padding: 0 0.5rem; }
#product .pr-right .pr-go p {
  background: var(--ci-green);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 4px;
  padding: 14px 0;
  border-radius: var(--radius-md);
  margin: 0;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, transform 0.15s;
  box-shadow: 0 4px 14px rgba(134,205,83,0.3);
}
#product .pr-right .pr-go p:hover {
  background: var(--charcoal);
  color: var(--ci-green);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.15);
}

/* ---- [임시] 예약차단 버튼 (PC/모바일 공통) - 정규화 시 제거 ---- */
#product .pr-go-blocked {
  background: var(--gray-200);
  color: var(--gray-600);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 2px;
  padding: 14px 0;
  border-radius: var(--radius-md);
  cursor: not-allowed;
}

/* ---- pre 공통 ---- */
.checkPoint, .supPre, .supCxl, .inclusion, .notInclusion, .reviewContent {
  word-wrap: break-word;
  white-space: pre-wrap;
}


/* ================================================
  # 모바일 예약
================================================ */
#product .mobile-cal { display: block; }

#product .mobile-cal .openm {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--charcoal);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 2px;
  padding: 15px 0;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  cursor: pointer;
  z-index: 500;
  transition: background 0.2s;
}
#product .mobile-cal .openm:hover { background: var(--ci-green-dark); }

#product .mobile-cal .modal2 {
  background: #fff;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  margin: 0;
  padding: 0;
  transition: top 600ms cubic-bezier(0.86, 0, 0.07, 1);
  top: 100%;
  position: fixed;
  left: 0;
  text-align: left;
  z-index: 1000;
}
#product .mobile-cal .modal2 .body {
  padding: 50px 16px 100px;
  position: relative;
}
#product .mobile-cal .modal2 .closem {
  position: absolute;
  top: 12px;
  right: 16px;
  color: var(--gray-400);
}

/* 달력 (모바일 modal 안) */
#product .modal2 .calendar { width: 100%; }
#product .modal2 .calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--charcoal);
  padding: 0.7rem 1rem;
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
}
#product .modal2 .calendar-header-date { font-size: 1.3rem; font-weight: 700; color: #fff; }
#product .modal2 .calendarbtn {
  border: none;
  background: transparent;
  color: var(--ci-green);
  font-size: 1.1rem;
  padding: 4px 8px;
  cursor: pointer;
}
#product .modal2 .calendar-body { padding: 0.5rem 0; }
#product .modal2 .calendar-row { display: flex; margin: 4px 0; }
#product .modal2 .calendar-day-header {
  width: calc(100% / 7);
  text-align: center;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--gray-600);
  padding: 4px 0;
}
#product .modal2 .calendar-day {
  width: calc(100% / 7);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 2px;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: background 0.15s;
}
#product .modal2 .calendar-day:hover { background: var(--ci-green-light); }
#product .modal2 .calendar-date { font-size: 1rem; color: var(--text-main); }
#product .modal2 .calendar-day.today .calendar-date {
  background: var(--ci-green);
  color: #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border: none;
}
#product .modal2 .calendar-day.selected { background: var(--ci-green-light); }
#product .modal2 .calendar-day.selected .calendar-date { color: var(--ci-green-dark); font-weight: 700; }
#product .modal2 .calendar-price { font-size: 0.7rem; color: var(--ci-green-dark); font-weight: 600; margin-top: 1px; }

/* 모바일 옵션 */
#product .modal2 .price { padding: 0.3rem 0.5rem; }
#product .modal2 .price table { width: 100%; }
#product .modal2 .total-P { padding: 0 0.5rem; }
#product .modal2 .total-P table { width: 100%; }

/* 모바일 예약하기 버튼 */
#product .modal2 .pr-go { margin: 0.5rem 0 0.8rem; }
#product .modal2 .pr-go p {
  background: var(--ci-green);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 3px;
  padding: 15px 0;
  border-radius: var(--radius-md);
  margin: 0;
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: 0 4px 14px rgba(134,205,83,0.3);
}
#product .modal2 .pr-go p:hover { background: var(--charcoal); color: var(--ci-green); }

/* 열렸을 때 */
#product .mobile-cal .open {
  top: 5%;
  z-index: 1000;
  box-shadow: 0 -8px 30px rgba(0,0,0,0.15);
}

/* PC에선 모바일 숨김 */
@media (min-width: 992px) {
  #product .mobile-cal { display: none; }
}

/* 이미지 전체폭 (모바일 상세) */
.full-width-row {
  position: relative;
  left: 50%;
  right: 50%;
  width: 100vw;
  margin-left: -50vw;
  margin-right: -50vw;
  padding: 0 !important;
  overflow-x: hidden;
}

/* 달력 전역 기본값 (하위 호환) */
.calendar { display: inline-block; border: 0; font-family: sans-serif; width: 90%; }
.calendar-header { display: flex; justify-content: space-between; align-items: center; padding: 4px 0 10px; border-bottom: 1px solid var(--gray-200); }
.calendar-header-date { font-size: 1.5rem; font-weight: bold; }
.calendar-body { display: flex; flex-direction: column; }
.calendar-row { display: flex; margin: 2px 0; cursor: pointer; }
.calendar-day-header { width: calc(100% / 7); text-align: center; padding: 5px; }
.calendar-day { width: calc(100% / 7); display: flex; flex-direction: column; align-items: center; padding: 3px; }
.calendar-day.today { background: transparent; }
.calendar-day.today .calendar-date {
  background: var(--ci-green);
  color: #fff;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border: none !important;
}
.calendar-day.selected { background: var(--ci-green-light); }
.calendar-date { font-size: 1.1rem; font-weight: normal; color: var(--gray-600); }
.calendar-price { margin-top: 3px; font-size: 0.75rem; font-weight: bold; color: var(--ci-green-dark); }
.calendarbtn { border: 0; background: transparent; }
.pr-right { position: sticky; top: 0; }
.doInput::placeholder { font-size: 0.9rem; color: lightgray; }

/* 큐잉문서 */
.cueing-wrap {
  width: 100%;
  overflow-x: auto;
}
.cueing-wrap img {
  max-width: 100% !important;
  height: auto !important;
}
.cueing-wrap * {
  box-sizing: border-box;
}

.cueing-iframe-wrap {
  position: relative;
  width: 100%;
}
/* iOS + PC: 기존 방식 */
.cueing-iframe {
  display: block;
  width: 100%;
  min-height: 600px;
  border: 0;
  overflow: visible;
  background: #fff;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
  pointer-events: auto;
}

/* Android 오버레이 */
.cueing-touch-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: transparent;
}

.productDetail,
.productDetail .tab-pane,
.productDetail .row {
  overflow: visible !important;
}

@media (max-width: 991px) {
  .cueing-iframe {
    min-height: 400px;
  }
}
</style>

<style>
.markdown-body,
.ql-editor {
  color: #222 !important;
  background: none !important;
}
.markdown-body img,
.ql-editor img {
  max-width: 100% !important;
  height: auto !important;
  display: block !important;
}
.container .markdown-body,
.container .ql-editor {
  max-width: 100% !important;
  width: 100% !important;
  box-sizing: border-box !important;
  overflow-x: auto !important;
}
.ql-editor .ql-image-resize img {
  max-width: none !important;
  width: auto !important;
  height: auto !important;
  display: block !important;
  float: none !important;
  margin: 0 !important;
}
</style>